import type { Tool } from '@tools-beaver/shared';
import { ToolCard } from './ToolCard';
import { Loader2 } from 'lucide-react';

interface ToolListProps {
  tools: Tool[];
  isLoading?: boolean;
  title?: string;
  emptyMessage?: string;
}

export function ToolList({ tools, isLoading, title, emptyMessage = 'No tools found.' }: ToolListProps) {
  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-silver-400">
        <Loader2 size={32} className="animate-spin mb-3" />
        <p className="text-sm">Looking for tools nearby…</p>
      </div>
    );
  }

  return (
    <div>
      {title && (
        <h2 className="font-display font-bold text-xl text-silver-800 mb-4">{title}</h2>
      )}
      {tools.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-silver-400">
          <span className="text-5xl mb-3">🔍</span>
          <p className="text-sm">{emptyMessage}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {tools.map((tool) => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      )}
    </div>
  );
}
